import { render, staticRenderFns } from "./SocialAmbassadorPopup.vue?vue&type=template&id=219bc428&"
import script from "./SocialAmbassadorPopup.vue?vue&type=script&lang=js&"
export * from "./SocialAmbassadorPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports